import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "my-8 px-12" }
const _hoisted_2 = { class: "mt-1 relative rounded-xl shadow-sm w-338 mr-4 h-42 mb-5" }
const _hoisted_3 = { class: "input-icon-wrapper z-40" }
const _hoisted_4 = {
  key: 0,
  class: "h-42 w-full bg-gray-200 mb-5 animate-pulse2 rounded-xl"
}
const _hoisted_5 = { class: "relative mt-1" }
const _hoisted_6 = { class: "block truncate" }
const _hoisted_7 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_8 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_9 = { class: "grid grid-cols-1 lg:grid-cols-5 gap-5 md:gap-10 transition-all overflow-x-scroll scroll-smooth hidden-scroll" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "my-8 font-semibold text-3xl" }, "Charging Stations", -1)
const _hoisted_11 = {
  key: 0,
  class: "flex flex-col w-full",
  "aria-label": "Loading data"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-[292px] rounded-sm bg-gray-200 mb-10 animate-pulse2" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "w-full h-[292px] rounded-sm bg-gray-200 mb-10 animate-pulse2" }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 2,
  class: "bg-white py-20"
}

import OccupancyCard from '@/components/shared/OccupancyCard.vue';
import EmptyState from '@/components/shared/EmptyState.vue';
import Station from '@/components/Station.vue';
import { onMounted, inject, ref, watch, computed } from 'vue';
import { getLocation, getStatus } from '@/services/api.service';
import { AxiosStatic } from 'axios';
import { Location } from '@/types/interface';
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue';
import { CheckIcon, SelectorIcon, SearchIcon } from '@heroicons/vue/solid';
import { StationBay } from '@/types/interface';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const $axios = inject('$axios') as AxiosStatic;
const stations = ref([]);
const stationRaw = ref<StationBay[]>([]);
const mountOnce = ref(false);

const isLoading = ref(false);
const locations = ref<Location[]>([]);

const selectedLocation = ref({
  name: '',
  id: '',
});

const handleLocation = async () => {
  isLoading.value = true;
  try {
    const { data } = await getLocation($axios);
    locations.value = data;
    selectedLocation.value = locations.value[0];
  } catch (e: any) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const handleStatus = async () => {
  isLoading.value = true;
  try {
    const { data } = await getStatus($axios, selectedLocation.value.id);
    stationRaw.value = data;
    // data.map((res) => {
    //   res.bayHoggingIncident = false;
    //   res.icingIncident = false;
    //   res.charging = false;
    //   res.available = false;
    // });
    const groupByKey = (list: any[], key: string) =>
      list.reduce(
        (hash, obj) => ({
          ...hash,
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        }),
        {}
      );
    const result = groupByKey(data, 'stationId');
    stations.value = result;
  } catch (error) {
  } finally {
    isLoading.value = false;
  }
};

const computedStats = computed(() => {
  const available = stationRaw.value.filter(
    (station) => station.available === true
  );
  const charging = stationRaw.value.filter(
    (station) => station.charging === true
  );
  const iceing = stationRaw.value.filter(
    (station) => station.icingIncident === true
  );

  const bayHoggingIncident = stationRaw.value.filter((station) => {
    return station.bayHoggingIncident && !station.icingIncident;
  });

  const occupied = stationRaw.value.filter((station) => {
    return (
      !station.available &&
      !station.charging &&
      !station.icingIncident &&
      !station.bayHoggingIncident
    );
  });

  // bayHoggingIncident.map((station) => {
  //   station.icingIncident === false;
  // });

  return {
    available,
    charging,
    bayHoggingIncident,
    iceing,
    occupied,
  };
});
watch(
  () => [selectedLocation.value],
  async () => {
    if (mountOnce.value) {
      await handleStatus();
    }
  }
);
onMounted(async () => {
  await handleLocation();
  await handleStatus();
  mountOnce.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(SearchIcon), {
          class: "h-7 w-7 text-gray-400",
          "aria-hidden": "true"
        })
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : (_openBlock(), _createBlock(_unref(Listbox), {
            key: 1,
            modelValue: selectedLocation.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedLocation).value = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(ListboxButton), { class: "relative w-full py-2 pl-16 pr-10 h-42 text-left bg-white input-main" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(selectedLocation.value.name), 1),
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_unref(SelectorIcon), {
                        class: "w-5 h-5 text-gray-400",
                        "aria-hidden": "true"
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, {
                  "leave-active-class": "transition duration-100 ease-in",
                  "leave-from-class": "opacity-100",
                  "leave-to-class": "opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ListboxOptions), { class: "absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (location) => {
                          return (_openBlock(), _createBlock(_unref(ListboxOption), {
                            key: location.name,
                            value: location,
                            as: "template"
                          }, {
                            default: _withCtx(({ active, selected }) => [
                              _createElementVNode("li", {
                                class: _normalizeClass([
                    active ? 'text-amber-900 bg-amber-100' : 'text-gray-900',
                    'cursor-default select-none relative py-2 pl-10 pr-4',
                  ])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-xl", [
                      selected ? 'font-medium' : 'font-normal',
                      'block truncate',
                    ]])
                                }, _toDisplayString(location.name), 3),
                                selected
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                      _createVNode(_unref(CheckIcon), {
                                        class: "w-5 h-5",
                                        "aria-hidden": "true"
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(OccupancyCard, {
          name: "Available",
          status: _unref(computedStats).available
        }, null, 8, ["status"]),
        _createVNode(OccupancyCard, {
          name: "Occupied",
          status: _unref(computedStats).occupied
        }, null, 8, ["status"]),
        _createVNode(OccupancyCard, {
          name: "Charging",
          status: _unref(computedStats).charging
        }, null, 8, ["status"]),
        _createVNode(OccupancyCard, {
          name: "Iceing",
          status: _unref(computedStats).iceing
        }, null, 8, ["status"]),
        _createVNode(OccupancyCard, {
          name: "Bay Hogging",
          status: _unref(computedStats).bayHoggingIncident
        }, null, 8, ["status"])
      ])
    ]),
    _createElementVNode("section", null, [
      _hoisted_10,
      _createElementVNode("div", {
        class: _normalizeClass(["flex justify-between flex-wrap bg-white px-9 py-14 h-full min-h-[65vh]", { '!justify-center': !isLoading.value && stationRaw.value.length <= 0 }])
      }, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
          : (!isLoading.value && stationRaw.value.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(stations.value, (station, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createVNode(Station, {
                    station: station,
                    stations: stations.value,
                    class: "p-5"
                  }, null, 8, ["station", "stations"])
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(EmptyState)
              ]))
      ], 2)
    ])
  ]))
}
}

})